export default __webpack_public_path__ + "static/media/BANNERHEADER.1fa6d7fa.png";